import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Summary} from './components/Publications'

const PublicationsTeaser: React.FC = () =>  {
    const intl = useIntl()
    const [total, setTotal] = useState(0);
    return(
        <div className='card mb-5 mb-xl-10'>
            <div className='card-body pt-9 pb-0'>
                <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                    <div className='flex-grow-1'>
                        <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                            <div className='d-flex flex-column'>
                                <div className='d-flex align-items-center mb-2'>
                                    <div className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                                        {intl.formatMessage({id: 'EDHEC.LABEL.MY_PUBLICATIONS'})}<span className='text-muted fs-5'> ({total})</span>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex mb-4'>
                                <Link to='/publications/my-publications' className='btn btn-sm btn-primary me-3'>
                                    <KTSVG
                                        path='/media/icons/duotune/general/gen021.svg'
                                        className='svg-icon-1 svg-icon-primary'
                                    />
                                    {intl.formatMessage({id: 'EDHEC.BUTTON.SEE'})}
                                </Link>
                                <Link to='/publications/add' className='btn btn-sm btn-primary me-3'>
                                    <KTSVG
                                        path='/media/icons/duotune/arrows/arr075.svg'
                                        className='svg-icon-1 svg-icon-primary'
                                    />
                                    {intl.formatMessage({id: 'EDHEC.BUTTON.ADD'})}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <Summary setTotal={setTotal}/>
            </div>
        </div>
    )
}
export default PublicationsTeaser